import React, { useEffect, useState } from 'react';
import { useTimer } from 'react-timer-hook';
import { verificationCodeBySMS, } from '../redux/login/actions';
import cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';

function MyTimer({ expiryTimestamp, mobileNumber }) {
    const dispatch = useDispatch();

    const {
        sendVerificationCode,
    } = useSelector((state) => ({
        sendVerificationCode: state.loginOrRegisterReducer.sendVerificationCode,
    }));

    const {
        totalSeconds,
        seconds,
        minutes,
        hours,
        days,
        isRunning,
        start,
        pause,
        resume,
        restart,
    } = useTimer({
        expiryTimestamp, onExpire: () => {
            setDisabled(false);
            cookies.remove('login-timer');
            setDisplayColor('text-green-600 border-b-green-600');
        }
    });

    const [disabled, setDisabled] = useState(true);
    const [diaplayColor, setDisplayColor] = useState('text-black border-b-black');
    const [time, setTime] = useState('');

    const onResendVerificationcode = (event) => {
        event.preventDefault();
        let data = { mobileNumber: mobileNumber };

        dispatch(verificationCodeBySMS(data)).then(() => {
            let timer = '';
            timer = cookies.get('login-timer');
            setDisabled(true);
            const time = Number(timer);
            setTime(time);
            restart(time)
            setDisplayColor('text-black');
        });

    };

    useEffect(() => {
        console.log(sendVerificationCode);
        let timer;
        timer = cookies.get('login-timer');
        setTime(Number(timer));
    }, [sendVerificationCode]);


    return (
        <div>
            <div className='text-forthText mx-7 mt-8 mb-5 flex justify-center items-center text-sm w-full'>
                <button
                    onClick={(event) => onResendVerificationcode(event)}
                    className={`${disabled ? 'bg-lightBorder' : 'bg-secondary-100'}
                        mx-2 col-5 font-medium text-right font-bold p-2 rounded-md`}
                    disabled={disabled}
                >
                    {locales('send.code.again')}
                </button>
                {locales('code.does.not.sent')}
            </div>
            <div className='text-center text-lg'>
                <span>{minutes}</span>:<span>{seconds}</span>
            </div>
        </div>
    );
}

export default MyTimer;

// export default function App() {
//     const time = new Date();
//     time.setSeconds(time.getSeconds() + 600); // 10 minutes timer
//     return (
//         <div>
//             <MyTimer expiryTimestamp={time} />
//         </div>
//     );
// }